import { createContext } from 'react'

import { PrebidStackFormContextType } from './types'

export const PrebidStackFormContext = createContext<PrebidStackFormContextType>(
  {} as PrebidStackFormContextType,
)
